import { useSearchParams } from 'react-router-dom';
import './styles.scss';
import Checkbox from '../../../../ui/checkbox';

export const RememberMePiece: React.FC<{
  rememberMeBlock: boolean | undefined;
}> = ({ rememberMeBlock }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const goToForgot = (): void => {
    searchParams.set('auth', 'forgot');
    setSearchParams(searchParams, { replace: true });
  };
  if (rememberMeBlock) {
    return (
      <div className="inputBottomRow">
        <div className="inputBottomCel">
          <Checkbox className="rememberCheckbox">
            <p className="inputBottomCelTextBottom">Remember me</p>
          </Checkbox>
        </div>
        <div className="inputBottomCel">
          <p className="inputBottomCelTextLink" onClick={goToForgot}>
            Forgot password?
          </p>
        </div>
      </div>
    );
  }
  return <></>;
};
